
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help-online",
      function () {
        return require("private-next-pages/help-online/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help-online"])
      });
    }
  